/**
 * <p-faq-accordion> — FAQ-Akkordeon (Ersatz für Hypers accordion-details / accordion-group).
 * Umschließt <details class="…" aria-expanded>-Elemente mit <summary> + Inhalt.
 * - weiches Auf-/Zuklappen wie Hyper: Höhe 0,25 s ease, Inhalt Opacity + translateY(10px) 0,15 s
 * - data-single: nur eine Frage gleichzeitig offen
 * - setzt aria-expanded am <details> (CSS dreht darüber den Pfeil)
 * - Theme-Editor: Block auswählen öffnet die Frage
 */
if (!customElements.get('p-faq-accordion')) {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class PFaqAccordion extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('details')];
      this.items.forEach((details) => {
        const summary = details.querySelector('summary');
        details.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        summary?.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle(details, details.getAttribute('aria-expanded') !== 'true');
        });
      });

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          const details = e.target.querySelector?.('details') || e.target.closest?.('details');
          if (details) this.toggle(details, true);
        });
      }
    }

    toggle(details, open) {
      if (open && this.hasAttribute('data-single')) {
        this.items.forEach((other) => {
          if (other !== details && other.getAttribute('aria-expanded') === 'true') this.toggle(other, false);
        });
      }
      details.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.animate(details, open);
    }

    async animate(details, open) {
      const summary = details.querySelector('summary');
      const content = summary?.nextElementSibling;
      details.animations?.forEach((a) => a.cancel());

      if (reduced() || !summary || !content || !details.animate) {
        details.open = open;
        return;
      }

      details.style.overflow = 'hidden';
      let animations;
      if (open) {
        details.open = true;
        animations = [
          details.animate(
            { height: [`${summary.clientHeight + 1}px`, `${details.scrollHeight + 1}px`] },
            { duration: 250, easing: 'ease' }
          ),
          content.animate(
            { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
            { duration: 150 }
          ),
        ];
      } else {
        animations = [
          content.animate({ opacity: [1, 0] }, { duration: 150, fill: 'forwards' }),
          details.animate(
            { height: [`${details.clientHeight + 1}px`, `${summary.clientHeight + 1}px`] },
            { duration: 250, easing: 'ease' }
          ),
        ];
      }
      details.animations = animations;

      try {
        await Promise.all(animations.map((a) => a.finished));
      } catch (e) {
        return; // abgebrochen durch erneuten Klick
      }
      if (!open) details.open = false;
      animations.forEach((a) => a.cancel());
      details.animations = null;
      details.style.overflow = '';
    }
  }

  customElements.define('p-faq-accordion', PFaqAccordion);
}
